export enum Factors {
	DATE = 1000,
	CURRENCY = 100
}

export const MAX_TIME = 8640000000000000;

export function capitalize(value: string) {
	if (!value) return;
	return value.charAt(0).toUpperCase() + value.slice(1);
}

export function newDate(time = false) {
	const d = new Date();
	if (!time) {
		d.setHours(0, 0, 0, 0);
	}
	return d;
}

export function download(data: any, filename: string) {
	const url = URL.createObjectURL(data);
	const link = document.createElement('a');
	document.body.appendChild(link);
	link.href = url;
	link.target = '_blank';
	link.download = filename;
	link.click();
	setTimeout(() => {
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	}, 100);
}

export function leftPad(s: string, size: number, char: string) {
	let pad = '';
	while ((pad.length + s.length) < size) pad += char;
	return pad + s;
}

export function scrollToElement(el: HTMLElement) {
	window.scroll(0, el.offsetTop);
}

export function getValueByPath(obj: any, path: string) {
	return path.split('.').reduce((o, i) => o[i], obj);
}

export function convertIntNumber(value: any): number {
	if (typeof value === 'string')
		return parseInt(value.replace(/\./g, ''), 10);
	return value;
}

export function convertFloatNumber(value: any): number {
	if (typeof value === 'string')
		return parseFloat(value.replace(/\./g, ''));
	return value;
}

export function num2Date(value: number): Date | undefined {
	return value ? new Date(value * Factors.DATE) : undefined;
}

export function date2Num(value: Date): number | undefined {
	return value ? Math.round(value.getTime() / Factors.DATE) : undefined;
}

export function cent2double(value: number): number | undefined {
	return value !== null && typeof value !== 'undefined' ? value / Factors.CURRENCY : undefined;
}

export function double2cent(value: number): number | undefined {
	return value !== null && typeof value !== 'undefined' ? Math.round(value * Factors.CURRENCY) : undefined;
}

export function num2Bool(value: number): boolean {
	return !!value;
}

export function bool2Num(value: boolean): number {
	if (value === null) return 0;
	return value ? 1 : 0;
}

// type 0: toClass, 1 toPlain
export function dateTransform(value: any, obj: any, type: any): number | Date | undefined {
	if (type === 0) {
		return num2Date(value);
	} else {
		return date2Num(value);
	}
}

// type 0: toClass, 1 toPlain
export function centTransform(value: number, obj: any, type: any): number | undefined {
	if (type === 0) {
		return cent2double(value);
	} else {
		return double2cent(value);
	}
}

// type 0: toClass, 1 toPlain
export function booleanTransform(value: any, obj: any, type: any): number | boolean | undefined {
	if (type === 0) {
		return num2Bool(value);
	} else {
		return bool2Num(value);
	}
}

export function timeTransform(value: any, obj: any, type: number): string | Date | undefined {
	if (type === 0) {
		if (!value) return;
		const time = (value as string).split(':');
		const hours = time[0];
		const minutes = time[1];
		const d = new Date();
		d.setDate(1);
		d.setMonth(1);
		d.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
		return d;
	} else {
		if (!value) return;
		const d: Date = value;
		const hours = d.getHours();
		const minutes = d.getMinutes();
		return `${leftPad(hours.toString(), 2, '0')}:${leftPad(minutes.toString(), 2, '0')}`;
	}
}

export function isNotBlank(value: any) {
	return typeof value !== 'undefined' && value !== null && value !== '';
}

export function currencyToNumber(val: string) {
	const value = val.replace('.', '').replace(',', '.');
	return parseFloat(value);
}

export function numberOfDaysInMonth(year: number, month: number) {
	return new Date(year, month + 1, 0).getDate();
}

export function firstDayOMonth(date?: Date) {
	const d = date ? date : newDate();
	d.setDate(1);
	return d;
}

export function lastDayOfMonth(date?: Date) {
	const d = date ? date : newDate();
	d.setDate(numberOfDaysInMonth(d.getFullYear(), d.getMonth()));
	return d;
}

export function dateEndofDay(t: Date) {
	const d = new Date(t);
	d.setHours(23, 59, 59);
	return d;
}

export function dateStartofDay(t: Date) {
	const d = new Date(t);
	d.setHours(0, 0, 0, 0);
	return d;
}

export function mergeDates(origin: Date, destination: Date) {
	const startyear = origin.getFullYear();
	const startmonth = origin.getMonth();
	const startdate = origin.getDate();
	destination.setFullYear(startyear);
	destination.setMonth(startmonth);
	destination.setDate(startdate);
	return destination;
}

export function numberMask() {
	return {
		numeral: true,
		numeralDecimalMark: ',',
		delimiter: '.',
		numeralPositiveOnly: true
	};
}